import "./ImgScaler.css";
import React, { Component } from "react";
import ImageLoader from "./common/ImageLoader";

class ImgScaler extends Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    this.cropperRef = React.createRef();
    // useRef<HTMLImageElement>(null);
  }

  uploadFileButton = () => {
    if (this.props.handleUploadInitImage !== null) {
      this.myRef.current.click();
    }
  };

  handleUploadFileEvent = (e) => {
    const file = e.target.files[0];
    const url = URL.createObjectURL(file);
    this.props.handleUploadInitImage(file, url);
    e.target.value = null;
  };
  render() {
    return (
      <div className="scaler-container">
        <div
          style={{
            color: "white",
            textAlign: "center",
            fontSize: "10pt",
            margin: "5px",
          }}
        >
          {"Upscale Image "}
          {/* <FaQuestionCircle size={15} onClick={() => this.setState({ showHelp: true })} style={{ verticalAlign: "middle", cursor: "pointer" }} /> */}
        </div>
        {this.props.loading ? <ImageLoader /> : null}
        <div style={{ width: "100%", height: "80%", textAlign: "center" }}>
          <img
            src={this.props.initImageURL}
            alt="GeneratedImage"
            className="scaler-image"
            style={{ cursor: "pointer" }}
            onClick={this.uploadFileButton}
          />
          {this.props.handleUploadInitImage !== null && (
            <div
              style={{
                fontSize: "10px",
                textAlign: "center",
                cursor: "pointer",
                color: "white",
              }}
              onClick={this.uploadFileButton}
            >
              {"Click to Upload File"}
            </div>
          )}
          <input
            type="file"
            id="file"
            ref={this.myRef}
            onChange={this.handleUploadFileEvent}
            accept=".jpg, .png"
          />
        </div>
        <div className="button-upscale" onClick={() => this.props.submit("")}>
          {/* <MdPhotoSizeSelectLarge style={{ verticalAlign: "middle" }} size={25} /> */}
          {" Submit"}
        </div>
      </div>
    );
  }
}

export default ImgScaler;
